export default __webpack_public_path__ + "static/media/abeii.85869ea8.jpg";